import React from "react";
import { AsianEvent1x2 } from "../../../AsianEventMarketPeriod/components/AsianEventMarket1x2/AsianEvent1x2";
import "./AsianEventCell1x2.scss";

const AsianEventCell1X2 = (props: Record<string, any>): React.JSX.Element => {
  const { marketPeriods, event, addBetSlip, highestNumberOfMarkets, line } =
    props;
  return (
    <React.Fragment>
      {marketPeriods &&
        marketPeriods.map(marketPeriod => {
          return (
            <div
              className="asian-marketPeriod-container oneXTwo"
              key={"aec1x2_" + event.id + "_" + marketPeriod.marketPeriod}
            >
              {marketPeriod.marketTypes.map(marketType => {
                return (
                  <AsianEvent1x2
                    key={`${event.id}_${marketType.marketType}`}
                    market={marketType.markets[0]}
                    addBetSlip={addBetSlip}
                    event={event}
                    highestNumberOfMarkets={highestNumberOfMarkets}
                    line={line}
                    row={true}
                  />
                );
              })}
            </div>
          );
        })}
    </React.Fragment>
  );
};

export default AsianEventCell1X2;
